import script from "./AddAdmin.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddAdmin.vue?vue&type=script&lang=ts&setup=true"

import "./AddAdmin.vue?vue&type=style&index=0&id=d79f7126&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d79f7126"]])

export default __exports__